import React from 'react';

import { LayoutContainer as ContainerQueryLayoutContainer } from './container-query/layout-container';
import { LayoutContainer as ResizeObserverLayoutContainer } from './resize-observer-fallback/layout-container';
import { doesBrowserSupportContainerQuery } from '../../../../services/browser-support-service';

/**
 * @param {object} props
 * @param {React.ReactNode} [props.column1Sections]
 * @param {React.ReactNode} [props.column2Sections]
 * @param {React.ReactNode} [props.column3Sections]
 * @param {React.ReactNode} props.fulfillmentPlannerSections
 * @param {React.ReactNode} props.primaryShipmentSections
 * @param {React.ReactNode} [props.rateCard]
 * @param {React.ReactNode} props.secondaryShipmentSections
 * @returns {JSX.Element}
 */
export const SelectedContentLayoutLoader = (props) => {
  return doesBrowserSupportContainerQuery ? <ContainerQueryLayoutContainer {...props} /> : <ResizeObserverLayoutContainer {...props} />;
};
